import { render, staticRenderFns } from "./useripwhitelist.vue?vue&type=template&id=c02c8b5e&"
import script from "./useripwhitelist.vue?vue&type=script&lang=js&"
export * from "./useripwhitelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports